import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { profileApi, queryClient } from '~/lib/request';

export function useUpdateAvatar() {
  return useMutation<unknown, Error, string>({
    mutationFn: async (avatarUrl: string) => {
      if (avatarUrl.startsWith('blob:')) {
        const body = new FormData();
        const fileResult = await fetch(avatarUrl);
        const blob = await fileResult.blob();

        body.append(
          'avatar',
          new File([blob], 'avatar.jpg', {
            type: blob.type,
          }),
        );

        await profileApi.post('api/profile/me/avatar', { body });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
      toast.success('Avatar updated successfully!');
    },
    onError: () => {
      toast.error('Failed to update avatar');
    },
  });
}
